// Shared nav item list consumed by both the desktop tab row and the mobile
// menu (Header/index.tsx and Header/MobileMenu.tsx) so they can't drift apart.
export interface NavItem {
  key: string;
  path: string;
}

// The 6 tabs shown as underlined links on desktop / list items on mobile.
export const LANDING_NAV_TABS: NavItem[] = [
  { key: "home", path: "/" },
  { key: "vision", path: "/vision" },
  { key: "partnership", path: "/partnership" },
  { key: "platform", path: "/platform" },
  { key: "team", path: "/team" },
  { key: "testimonials", path: "/testimonials" },
];

export const LANDING_DONATE_ITEM: NavItem = { key: "donate", path: "/donate" };
export const LANDING_CONTACT_ITEM: NavItem = { key: "contact_us", path: "/contact-us" };
